import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Icon, Line, Modal } from '@/UI';
import DateIndicator from '@/UI/date-indicator/DateIndicator';
import SearchInput from '@/UI/search-input/SearchInput';
import { onJoinChannel } from '@/Utils/socket-actions/ChannelActions/channelActions';
import { triggerScroll } from '@/Utils/targetMessageService';
import { sendWebSocketData } from '@/Utils/webSocketUtils';
import HashtagIcon from '@/assets/icons/HashtagIcon';
import SearchIcon from '@/assets/icons/SearchIcon';
import SearchImage from '@/assets/icons/SearchImage';
import VolumeIcon from '@/assets/icons/VolumeIcon';
import { ReactComponent as LockIcon } from '@/assets/icons/lock.svg';
import { DEFAULT_IMAGES } from '@/constants/index';
import useChatHelper from '@/hooks/useChatHelper';
import { useAppSelector } from '@/hooks/useRedux';
import { backendSearchActions } from '@/store/backend-search-results';
import {
    activeChannelIdSelector,
    channelDataSelector,
    memberDataSelector,
    serverDataSelector,
} from '@/store/server-data-reducer/selectors-server-data';

import CustomErrorBoundary from '../CustomErrorBoundary/CustomErrorBoundary';
import UserModal from '../connections-section/user-modal/UserModal';
import Pagination from '../pagination/Pagination';

import classes from './Search.module.css';

const SearchDesktopTest = props => {
    const searchRef = useRef(null);
    const dispatch = useDispatch();
    const searchData = useAppSelector(
        state => state.indexedDBReducer.searchResults,
    );
    const [searchResult, setSearchResult] = useState([]);
    const [searchType, setSearchType] = useState('');
    const [pageResult, setPageResult] = useState([]);
    const [userModal, setUserModal] = useState({ userData: {}, state: false });
    const members = useAppSelector(state => memberDataSelector(state));
    const channel = useAppSelector(state => channelDataSelector(state));
    const serversData = useAppSelector(state => serverDataSelector(state));
    const { sendSearchKeyword } = useChatHelper();
    const SEARCH_ON_CHAT_SERVER = true;
    useEffect(() => {
        setSearchResult(searchData);
    }, [searchData]);
    const searchMessagesChatServer = trimmedKey => {
        setTimeout(() => {
            // const payload = {"action":"search_result","data":[{"message_id":"57140659-d614-4069-a536-ed2f224911db","sender_id":"23b6c421-6193-43b1-9821-aad5d8c54a59","channel_id":"83f9fc0a-e04e-443f-b25b-e2fc0be5525b","text":"test","created_at":"2023-10-24 11:56:03","token":""},{"message_id":"cfe5a517-78b6-4905-86eb-9e1b7a5310dd","sender_id":"23b6c421-6193-43b1-9821-aad5d8c54a59","channel_id":"5384e820-c8d9-4ccd-9b98-61621eedf893","text":"test","created_at":"2023-10-24 11:55:43","token":""},{"message_id":"2a2735a9-27a5-441c-a25a-a9252e011e9f","sender_id":"23b6c421-6193-43b1-9821-aad5d8c54a59","channel_id":"b28aa85f-4a46-41ec-b42a-fba07b95fd0f","text":"test","created_at":"2023-10-23 07:08:11","token":""},{"message_id":"38e02fe3-8f5f-4ab7-875a-d42bfbb0568b","sender_id":"23b6c421-6193-43b1-9821-aad5d8c54a59","channel_id":"1e31d78e-2c70-48c3-b9fb-ad1c5bd530ef","text":"video test","created_at":"2023-10-20 08:24:04","token":""},{"message_id":"2a70ddf3-04d7-4741-9d18-e37ecc36e352","sender_id":"8dcdd7d2-4419-4e49-bbc3-570bfd633b53","channel_id":"b28aa85f-4a46-41ec-b42a-fba07b95fd0f","text":"test ","created_at":"2023-10-19 09:29:49","token":""},{"message_id":"f463cfcf-45ab-4a56-b61e-9c3683b28148","sender_id":"23b6c421-6193-43b1-9821-aad5d8c54a59","channel_id":"83051af5-c38c-43a2-b758-b3744a56e155","text":"test","created_at":"2023-10-05 08:38:38","token":""},{"message_id":"0b4fe79f-953f-4018-ac9b-da02476a6797","sender_id":"23b6c421-6193-43b1-9821-aad5d8c54a59","channel_id":"dae18041-d971-42ae-bc0a-b5fb547d2d86","text":"test","created_at":"2023-10-02 13:20:43","token":""},{"message_id":"b52a015b-2dcf-40e7-8950-58ef8fb27314","sender_id":"863874a5-7957-493f-a551-dcda8225618c","channel_id":"512e702d-90d6-4aad-aa15-1062ee568b6e","text":"test","created_at":"2023-09-25 11:41:54","token":""},{"message_id":"40264576-745d-47c4-805d-d191f1d09516","sender_id":"23b6c421-6193-43b1-9821-aad5d8c54a59","channel_id":"5a509af2-878d-428e-862a-3f0e39080c54","text":"#Test - Umer ","created_at":"2023-09-22 08:11:39","token":""},{"message_id":"81bc7503-3106-4eb1-9810-e78f5a9eac39","sender_id":"863874a5-7957-493f-a551-dcda8225618c","channel_id":"5a509af2-878d-428e-862a-3f0e39080c54","text":"merhaba @hell hanim, bu kanala katilir misiniz? #Test Private ","created_at":"2023-09-21 14:13:28","token":""},{"message_id":"ebca4a64-cea7-4621-a63e-ac95f6aed639","sender_id":"23b6c421-6193-43b1-9821-aad5d8c54a59","channel_id":"643fbfeb-476e-45a1-bb85-4a35b5217074","text":"test","created_at":"2023-09-18 08:27:20","token":""},{"message_id":"083b5e85-35d8-47c1-bc59-c9a453eb7d15","sender_id":"8dcdd7d2-4419-4e49-bbc3-570bfd633b53","channel_id":"5a509af2-878d-428e-862a-3f0e39080c54","text":"test","created_at":"2023-09-15 09:28:54","token":""}],"user_id":"23b6c421-6193-43b1-9821-aad5d8c54a59"}
            const payload = {
                action: 'search',
                data: trimmedKey,
            };
            sendWebSocketData(JSON.stringify(payload));
        }, 150);
    };
    const backendResult = useSelector(
        state => state.BackendSearchResultsReducer.searchResults,
    );

    const bodyStyle = {
        height: 'max(80vh, 400px)',
    };

    const joinChannelHandler = channelId => {
        onJoinChannel(channelId);
        props.onClose();
    };

    useEffect(() => {
        if (searchType === 'Messages') {
            setSearchResult(backendResult);
        }
    }, [backendResult]);

    const activeChannelId = useAppSelector(activeChannelIdSelector);

    const changePageHandler = slicedArray => {
        setPageResult(slicedArray);
    };

    const clickMessageHandler = data => {
        if (data.channel_id !== activeChannelId) {
            onJoinChannel(data.channel_id);
        }
        data._id = data?.message_id; // fix converted message_id -> _id
        props.onClose();
        setTimeout(() => {
            triggerScroll(data);
            // props.onScrollIntoMessage(data);
        }, 500);
        // props.onScrollIntoMessage(data._id);
    };

    const removePrefix = value => {
        return {
            newValue: value.substring(1),
        };
    };

    function removeDuplicatesById(array) {
        const seenIds = new Set();
        const uniqueArray = [];

        for (const obj of array) {
            if (!seenIds.has(obj._id)) {
                seenIds.add(obj._id);
                uniqueArray.push(obj);
            }
        }
        return uniqueArray;
    }

    const searchForMessages = trimedKey => {
        setTimeout(() => {
            if (trimedKey !== '') {
                sendSearchKeyword(trimedKey);
            } else {
                dispatch(backendSearchActions.setBackEndSearchResult([]));
            }
        }, 150);
    };

    const searchForUsers = trimedKey => {
        setTimeout(() => {
            const { newValue } = removePrefix(trimedKey);
            if (newValue !== '') {
                const filterUsers = members.filter(
                    (user: any) =>
                        user?.name?.toLowerCase()?.includes(newValue) ||
                        user?.username?.toLowerCase()?.includes(newValue),
                );
                setSearchResult(filterUsers);
            } else {
                setSearchResult([]);
            }
        }, 100);
    };

    const searchForChannels = (trimedKey, type) => {
        setTimeout(() => {
            const { newValue } = removePrefix(trimedKey);
            if (newValue !== '') {
                const textChannels = channel.filter(
                    (ch: any) =>
                        ch.type === type &&
                        ch.privacy === 'channel' &&
                        ch?.name?.toLowerCase()?.includes(newValue),
                );
                setSearchResult(textChannels);
            } else {
                setSearchResult([]);
            }
        }, 100);
    };

    const searchForServers = trimedKey => {
        setTimeout(() => {
            const { newValue } = removePrefix(trimedKey);

            if (newValue !== '') {
                const filterServers = serversData.filter(server =>
                    server?.name?.toLowerCase().includes(newValue),
                );

                setSearchResult(filterServers);
            } else {
                setSearchResult([]);
            }
        }, 100);
    };

    const ChangeSearchValueHandler = search => {
        setSearchResult([]);
        const trimedKey = search.trim();
        switch (true) {
            // search for usernames
            case trimedKey.startsWith('@'):
                setSearchType('Users');
                searchForUsers(trimedKey);
                break;
            case trimedKey.startsWith('#'):
                setSearchType('Text Channels');
                searchForChannels(trimedKey, 'text');
                break;
            case trimedKey.startsWith('!'):
                setSearchType('Voice Channels');
                searchForChannels(trimedKey, 'voice');
                break;
            case trimedKey.startsWith('*'):
                setSearchType('Servers');
                searchForServers(trimedKey);

                break;
            default:
                SEARCH_ON_CHAT_SERVER
                    ? searchMessagesChatServer(trimedKey)
                    : searchForMessages(trimedKey);
                setSearchType('Messages');
                break;
        }
    };

    useEffect(() => {
        if (searchRef.current) {
            searchRef.current.focus();
        }
    }, []);

    return (
        <Modal
            className={classes.modal}
            header={props.searchTitle}
            bodyStyles={bodyStyle}
            headerIcon={<SearchIcon stroke={'var(--keep-white)'} />}
            onClose={() => {
                props.onClose();
            }}>
            <CustomErrorBoundary>
                <p className={classes['par']}>
                    You can search channels, servers, contacts and more...
                </p>
                <SearchInput
                    ref={searchRef}
                    className={classes['search-input']}
                    RemoveIcon
                    placeholder="# for text channels | @ for Users | * for Servers | ! for voice channels"
                    onChange={ChangeSearchValueHandler}
                />
                {searchType && <h2>Search for {searchType}:</h2>}
                <div className={classes['results-container']}>
                    {pageResult?.length > 0 ? (
                        <ul className={classes['search-list']}>
                            {pageResult?.map((result, key) => {
                                if (searchType === 'Messages') {
                                    const date = new Date(result.created_at);

                                    const messageChannel: any = channel?.find(
                                        (ch: any) =>
                                            ch?._id === result?.channel_id,
                                    );
                                    const sender: any = members?.find(
                                        (e: { id: string }) =>
                                            e?.id === result?.sender_id,
                                    );
                                    return (
                                        <div key={key}>
                                            <li
                                                className={
                                                    classes['search-item']
                                                }
                                                onClick={() =>
                                                    clickMessageHandler(result)
                                                }
                                                id={result._id}>
                                                <div
                                                    className={
                                                        classes['d-flex']
                                                    }>
                                                    <Icon
                                                        className={
                                                            classes['icon']
                                                        }
                                                        imageURL={
                                                            sender
                                                                ? sender?.profile_picture
                                                                : DEFAULT_IMAGES.PROFILE_IMAGE
                                                        }
                                                        name={
                                                            sender
                                                                ? sender?.name
                                                                : ''
                                                        }
                                                    />
                                                    <div
                                                        style={{
                                                            width: '100%',
                                                        }}>
                                                        <div
                                                            className={
                                                                classes[
                                                                    'd-flex'
                                                                ]
                                                            }>
                                                            <p
                                                                className={
                                                                    classes[
                                                                        'message'
                                                                    ]
                                                                }>
                                                                {sender
                                                                    ? sender?.name
                                                                    : ''}
                                                                {messageChannel && (
                                                                    <span
                                                                        className={
                                                                            messageChannel.privacy ===
                                                                            'direct'
                                                                                ? classes[
                                                                                      'message-private'
                                                                                  ]
                                                                                : classes[
                                                                                      'message-channel'
                                                                                  ]
                                                                        }>
                                                                        {messageChannel.privacy ===
                                                                        'channel'
                                                                            ? messageChannel.name
                                                                            : 'Direct Chat'}
                                                                    </span>
                                                                )}
                                                            </p>
                                                            <DateIndicator
                                                                fullDate
                                                                date={date}
                                                                className={
                                                                    classes.date
                                                                }
                                                            />
                                                        </div>
                                                        <p
                                                            className={
                                                                classes[
                                                                    'search-text'
                                                                ]
                                                            }>
                                                            {result.text
                                                                ?.content
                                                                ? result.text
                                                                      .content
                                                                : result.text}
                                                        </p>
                                                    </div>
                                                </div>
                                            </li>
                                            <Line />
                                        </div>
                                    );
                                } else if (searchType === 'Users') {
                                    return (
                                        <li
                                            key={key}
                                            className={classes['search-item']}
                                            id={result.user_id}
                                            onClick={() =>
                                                setUserModal({
                                                    userData: result,
                                                    state: true,
                                                })
                                            }>
                                            <div className={classes['d-flex']}>
                                                <Icon
                                                    className={classes['icon']}
                                                    imageURL={
                                                        result?.profile_picture
                                                            ? result?.profile_picture
                                                            : DEFAULT_IMAGES.PROFILE_IMAGE
                                                    }
                                                    name={
                                                        result.name
                                                            ? result.name
                                                            : 'icon'
                                                    }
                                                />
                                                <div>
                                                    <p>{result.name}</p>
                                                    <p>@{result.username}</p>
                                                </div>
                                            </div>
                                            <Line />
                                        </li>
                                    );
                                } else if (
                                    searchType === 'Text Channels' ||
                                    searchType === 'Voice Channels'
                                ) {
                                    return (
                                        <li
                                            key={key}
                                            className={classes['search-item']}
                                            id={result._id}
                                            onClick={() =>
                                                joinChannelHandler(result._id)
                                            }>
                                            <div className={classes['d-flex']}>
                                                {!result.is_public && (
                                                    <LockIcon
                                                        fill={'var(--text-2)'}
                                                        className={
                                                            classes[
                                                                'room-type-icon'
                                                            ]
                                                        }
                                                    />
                                                )}
                                                {result.is_public &&
                                                    result.type === 'text' && (
                                                        <HashtagIcon
                                                            className={''}
                                                        />
                                                    )}
                                                {result.is_public &&
                                                    result.type === 'voice' && (
                                                        <VolumeIcon
                                                            className={''}
                                                        />
                                                    )}

                                                <p>{result.name}</p>
                                            </div>
                                            <Line />
                                        </li>
                                    );
                                }
                            })}
                        </ul>
                    ) : (
                        <div className={classes['empty-result']}>
                            <SearchImage className={classes['search-img']} />
                            <p className={classes['no-result']}>
                                Results will be displayed here
                            </p>
                        </div>
                    )}
                    {searchType === 'Users' && userModal?.state && (
                        <UserModal
                            className={classes['user-modal']}
                            user={userModal?.userData}
                        />
                    )}
                </div>
                <Pagination
                    pagesArray={searchResult}
                    itemsPerPage={20}
                    pageRange={3}
                    onChangePage={changePageHandler}
                />
            </CustomErrorBoundary>
        </Modal>
    );
};
export default SearchDesktopTest;
